<template>
  <div class="bug-creation-module" data-cy="bug-creation-module">
    <div class="bug-creation-module__container">
      <header
        class="bug-creation-module__header"
        data-cy="bug-creation-module-title"
      >
        Bug Creation (for IT Dept Use Only)
      </header>
      <div class="bug-creation-module__content">
        <input 
          type="text"
          v-model="message"
          data-cy="bug-creation-module-textarea"
          placeholder="Enter your bug here"
        />
        <Button
          class="bug-creation-module__button"
          type="button"
          themeColor="primary"
          @click="createBugAsync"
          :disabled="message.length == 0"
          data-cy="bug-creation-module-submit"
        >
          Generate Bug
        </Button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { api } from "@/api";
import { handleResponsePromiseAsync } from "@/shared/helpers/apiHelper";
import { ref } from "vue";
import { useMainStore } from "@/stores/useMainStore";
import { useNotificationStore } from "@/stores/useNotificationStore";
import { NotificationTypeEnum } from "@/Domain/NotificationTypeEnum";
import { Button } from "@progress/kendo-vue-buttons";

const main = useMainStore();
const notificationStore = useNotificationStore();

const message = ref<string>("");

const createBugAsync = async () => {
  await handleResponsePromiseAsync(
    api.get("ThrowException", {
      userLogin: main.userLogin,
      message: message.value,
    }),
    () => {
      notificationStore.notify({
        message: "Bug created successfully",
        type: NotificationTypeEnum.success,
        duration: 5000,
      });
    },
    "BugCreationModule.vue",
    "createBugAsync",
    () => {
      notificationStore.notify({
        message: "Bug creation failed. Please try again.",
        type: NotificationTypeEnum.error,
        duration: 5000,
      });
    }
  );
};
</script>

<style scoped lang="scss">
.bug-creation-module {
  display: flex;
  flex-direction: column;
  gap: 20px;

  &__container {
    border: 1px solid #e8e8e8;
    background: white;
  }

  &__header {
    padding: 8px 15px;
    font-size: 13px;
    background: #efefef;
    border-bottom: 1px solid #e8e8e8;
    position: relative;
  }

  &__content {
    padding: 15px;
    display: flex;
    gap: 10px;
  }
  input {
    flex: 1;
  }
  &__button {
    max-width: 120px;
  }
}
</style>
